<template>
    <div class="DshTags">
        <Tag
            v-for="(tagItem, tagIndex) in list"
            :key="tagIndex"
            :name="tagIndex"
            :type="propsObj.type"
            :closable="propsObj.closable === false ? false : true"
            :checkable="propsObj.checkable"
            :checked="propsObj.checked"
            :color="propsObj.color || 'default'"
            :fade="propsObj.fade || false"
            :size="propsObj.size || 'medium'"
            @on-close="deleteTag($event, tagItem, tagIndex)"
            @on-change="changeChecked"
        >{{ tagItem }}</Tag>
    </div>
</template>

<script>
    export default {
        name: "DshTags",
        props: {
            list: {
                type: Array,
                default () {
                    return [];
                }
            },
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {
            // 删除标签
            deleteTag (event, item, index) {
                this.list.splice(index, 1);
                this.$emit("delete", item, index);
            },
            // 改变标签状态
            changeChecked (checked, name) {

            }
        }
    };
</script>

<style lang="less" scoped>
    .DshTags {

    }
</style>
<style lang="less">
    .DshTags {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshTags.vue